import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import BannerForm from '@components/marketing/banners/BannerForm'

import { ROUTE_MARKETING_BANNERS } from '@@partner:config/routes'

export default function BannerFormPage () {
  const { bannerId, brandSlug } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_MARKETING_BANNERS, {
    brandSlug
  })

  return (
    <div className="BannerFormPage">
      <h1 className="u-heading">
        {bannerId ? 'Редактирование' : 'Добавление'}
      </h1>
      <BannerForm bannerId={bannerId} onSaved={redirectToCatalog} />
    </div>
  )
}
